module.exports = "https://trybtryb-legacy.web.app/img/twitter.a276029d.svg";